import RegionTable from "./region-table"

const Region = ({data}: any) => {
    return ( 
        <div>
            <RegionTable data={data}/>
        </div>
     );
}
 
export default Region;